import React from "react";
import { MenuItem, ListItemText, ListItemIcon, Typography } from "@mui/material/";
import Select from "@mui/material/Select";
import styles from "../../screens/dashboard/dashboard.module.css";
import FormControl from "@mui/material/FormControl";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import themeStyle from "utils/styles/theme.style";

export default function FormControlComponent(props) {
    const {
        groupData,
        setGroup,
        group,
        formName,
        variant = "light",
    } = props;
    const isDashboard = variant === "dashboard";
    const accent = isDashboard
        ? themeStyle.color.light
        : themeStyle.color.secondary;

    const handleChange = (event) => {
        setGroup(event.target.value);
    };

    const labelMinWidth = isDashboard ? 132 : 105;

    const selectSx = isDashboard
        ? {
            color: accent,
            backgroundColor: "var(--primary-popup-background-color)",
            height: 38,
            borderRadius: "6px",
            fontFamily: themeStyle.font.fontFamilyPoppins,
            fontWeight: 600,
            fontSize: "14px",
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: accent,
                borderWidth: "1px",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: accent,
                borderWidth: "1px",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: accent,
            },
            ".MuiSvgIcon-root": {
                fill: accent,
            },
            "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                paddingLeft: "12px",
                paddingRight: "32px",
            },
        }
        : {
            color: accent,
            backgroundColor: "white",
            height: 35,
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: accent,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: accent,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: accent,
            },
            ".MuiSvgIcon-root ": {
                fill: accent,
            },
        };

    const menuPaperSx = isDashboard
        ? {
            backgroundColor: "var(--primary-popup-background-color)",
            border: `1px solid ${accent}`,
            borderRadius: "6px",
            marginTop: "4px",
        }
        : undefined;

    return (
        <FormControl size="small">
            <Select
                sx={selectSx}
                IconComponent={KeyboardArrowDownIcon}
                labelId="demo-select-small"
                id="demo-select-small"
                value={group}
                onChange={handleChange}
                displayEmpty
                MenuProps={
                    isDashboard ?
                        {
                            PaperProps: { sx: menuPaperSx },
                        }
                        :   undefined
                }
                renderValue={
                    group !== ""
                        ? () => (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    minWidth: labelMinWidth,
                                    maxWidth: 220,
                                }}
                            >
                                  <span
                                      className={
                                          isDashboard ?
                                              styles.autoSelectDashboard
                                              :   styles.autoSelect
                                      }
                                  >
                                      {
                                          groupData.filter(
                                              (item) => item?.id === group,
                                          )[0]?.name
                                      }
                                  </span>
                            </div>
                        )
                        : () => (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    minWidth: labelMinWidth,
                                    maxWidth: 220,
                                }}
                            >
                                  <span
                                      className={
                                          isDashboard ?
                                              styles.autoSelectDashboard
                                              :   styles.autoSelect
                                      }
                                  >
                                      {formName}
                                  </span>
                            </div>
                        )
                }
            >
                {groupData.map((group) => (
                    <MenuItem key={group.id} value={group.id}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: 120,
                                maxHeight: 20,
                            }}
                        >
                            <ListItemIcon>
                                <PeopleAltIcon
                                    sx={{
                                        color: accent,
                                        maxHeight: 20,
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                sx={{ fontSize: "13px" }}
                                primary={
                                    <Typography
                                        variant="h2"
                                        style={{
                                            fontSize: "14px",
                                            textAlign: "start",
                                            color: isDashboard
                                                ? "var(--primary-text-color)"
                                                : undefined,
                                        }}
                                    >
                                        {group.name}
                                    </Typography>
                                }
                            />
                        </div>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}